// Global store management
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// default modules------------------------------------------------------------------------------------------------------
import a4d_settings from "./modules/a4d_settings/a4d_settings";

// rootGetters
const getters = {
    TEST_MODE: state => state?.a4d_settings?.test_mode ?? false,
}


// plugins -------------------------------------------------------------------------------------------------------------

// Persistent local storage:
// https://github.com/championswimmer/vuex-persist
// todo: check if still needed, settings module already saves to cookie atm
// could still be useful for account settings
// import VuexPersistence from "vuex-persist";
// const vuexLocal = new VuexPersistence({
//     storage: window.localStorage,
//     modules: ['a4d_settings','a4d_checkout']
// })

export const store = new Vuex.Store({
    strict: true, // deny mutating states directly
    modules: {
        a4d_settings,
    },
    // plugins: [
    //     vuexLocal.plugin
    // ]
    getters
});
